
import { Component, Vue } from 'vue-property-decorator'
import OrderModal from '@/modules/order/OrderModal.vue'
import { OrdersStore } from '@/store/stores/OrdersStore'
import OrderFilter from '@/modules/order/OrderFilter.vue'
import { envConfiguration } from '@/plugins/globalStaticDatas'
import { OrderDetailModel } from '@/store/models/OrderDetailModel'

@Component({
  components: { OrderModal, OrderFilter },
})
export default class OrderList extends Vue {
  orders: OrdersStore = OrdersStore.getInstance()
  details: OrderDetailModel[] = []
  actualOrderNo: number = 0
  businessEmail: string = envConfiguration.businessEmail
  filters: any = {
    qs: '',
    ordering: '',
    sort_by: '',
    status: '',
  }

  openOrderModal(id: number) {
    const actualOrder = this.orders.findItem('id', id)
    this.details = actualOrder.details.getStore()
    this.actualOrderNo = actualOrder.id
    this.$modal.show('order-details')
  }

  prepareQuery(): string {
    let valueToSearch: string = this.filters.qs ? this.filters.qs.toLowerCase() : ''
    return `?qs=${valueToSearch}&page-size=&page=&ordering=${this.filters.ordering}&sort_by=${this.filters.sort_by}&status_id=${this.filters.status}&resource=OrderDetailedResource`
  }

  selectedFilters(data) {
    this.filters = data
    this.orders.loadData(this.prepareQuery())
  }

  orderStatuses(order: any) {
    return order.statusId === 12
      ? 'rejected-status'
      : order.statusId === 3
      ? 'success-status'
      : order.statusId === 5
      ? 'pending-status'
      : order.statusId === 16
      ? 'confirmed-status'
      : order.statusId === 1
      ? 'active-status'
      : order.statusId === 19
      ? 'draft-status'
      : order.statusId === 15
      ? 'is-sending-status'
      : ''
  }

  mounted() {
    this.orders.loadData(this.prepareQuery())
  }
}
